module.exports = __webpack_public_path__ + "img/symbol_3.ad710465.png";